import { useEffect, useState } from 'react';
import '../../styles/fix/input-dark.scss';
import { useParams } from "react-router-dom";
import { HttpStatus } from 'src/constant/responseStatus';
import { FavoriteService } from 'src/services/favoriteService';
import { PageDocument } from 'src/constant/stringConstants';
import JustifiedGallery from 'src/components/gallerySearch/JustifiedGallery';
import { AssetPublishModel } from 'src/models/assetModel';
import { ExtendedLicenseModel, StandardLicenseModel } from '@/src/models/LicenseModel';
import { AssetType } from 'src/constant/assetConstants';
import { StandardLicense } from 'src/constant/licenseConstants';
import { FavoriteResponseModel } from 'src/models/responses/favoriteModel';

export default function FavoriteCollection() {
  const { id } = useParams();
  const [assets, setAssets] = useState<AssetPublishModel[]>([]);
  const [favorite, setFavorite] = useState<FavoriteResponseModel>();

  useEffect(() => {
    document.title = `Favorite Collection - ${PageDocument.Title}`;

    if (id) {
      onGetFavoriteByIdAsync();
    }
  }, [id]);

  const onGetFavoriteByIdAsync = async () => {
    const
      {
        data: responseData,
        status: responseStatus
      } = await new FavoriteService().getFavoriteByIdAsync(id!);

    if (responseStatus !== HttpStatus.OK) {
      return;
    }

    setFavorite(responseData);

    const datas: AssetPublishModel[] = responseData.favoriteItems.map<AssetPublishModel>((item) => ({
      id: item.asset.id,
      assetType: item.asset.assetType,
      code: item.asset.code!,
      name: item.asset.name,
      description: item.asset.description!,
      thumbnailImageUrl: item.asset.thumbnailImageUrl!,
      thumbnailVideoUrl: item.asset.thumbnailVideoUrl!,
      thumbnailVideoCoverUrl: item.asset.thumbnailVideoCoverUrl!,
      hasSMLicense: item.asset.hasSMLicense,
      hasXLLicense: item.asset.hasXLLicense,
      hasHDLicense: item.asset.hasHDLicense,
      hasUHDLicense: item.asset.hasUHDLicense,
      publishDate: new Date(),
      hasCollection: false,
      keywords: item.asset.keywords!,
      userId: '',
      artistFirstname: item.asset.artistFirstname,
      artistLastname: item.asset.artistLastname,
      artistNameEn: item.asset.artistNameEn,
      standardLicense: {
        id: 'string',
        assetType: AssetType.IMAGE,
        code: StandardLicense.SM,
        name: 'string',
        price: 0,
        sequence: 0,
      } as StandardLicenseModel,
      extendedLicense: {
        id: 'string',
        assetType: AssetType.IMAGE,
        code: StandardLicense.SM,
        name: 'string',
        price: 0,
        liftTimeType: 0,
        liftTime: 0,
        sequence: 0,
      } as ExtendedLicenseModel,
      price: 0,
      isDisabled: false,
      isHasLicense: false,
      imageOrientation: item.asset.imageOrientation ?? item.asset.orientation,
      width: item.asset.width ?? 0,
      height: item.asset.height ?? 0,
      usage: item.asset.usage,
    }));

    setAssets(datas);
  }

  return (<>
    <div className='search pt-5 mt-5'>
      <div className='container'>
        <h1>
          {favorite?.name}
        </h1>
        <JustifiedGallery assets={assets} />
      </div>
    </div>
  </>);
}